<div class="">
  <div *ngIf="isLoginAsAdmin()" class="company-header text-center">
    <label class="btn change-company"><a href="https://dashboard.bmsroadtax.com/#/"
        target="_blank">Dashboard</a></label>
  </div>
  <br />
  <main class="main d-flex align-items-center">
    <div class="container">
      <ngx-spinner type="square-jelly-box">
        <p style="color: white"><strong> Loading... </strong></p>
      </ngx-spinner>
      <div class="row">
        <div style="text-align: center; width: 100%;">
          <a href="https://bmsroadtax.com"> <img width="100px" alt="bms logo" height="80"
              ngSrc="assets/img/bms-eplateform-logo.png" /></a>
        </div>
        <!-- <div class="col-md-3"></div>
        <div class="col-md-5">

          <label style="font-weight: bold;padding-left: 10px;">Brilliant Management Services
            (001166576-D)</label>
          <br /><br />
          <div style="text-align: center">
            <p style="font-weight: bold;">Renewal directly from Insurance Company</p>
          </div>
        </div>

        <div class="col-md-3"></div> -->
      </div>
      <br />
      <div class="col-md-{{cardWidth}} mx-auto">
        <div class="card">
          <div class="card-header"><strong>Vehicle Insurance Quotation</strong></div>
          <div class="card-body">


            <nz-steps [nzCurrent]="current" nzSize="small">
              <nz-step nzTitle="{{step1Title}}"></nz-step>
              <nz-step nzTitle="{{step2Title}}"></nz-step>
              <nz-step nzTitle="{{step3Title}}"></nz-step>
              <nz-step nzTitle="{{step4Title}}"></nz-step>
            </nz-steps>

            <div *ngIf="isMobileScreen">
              <br />
              <strong> {{mobileStepTitle}}</strong>
            </div>
            <div class="steps-content" *ngIf="current==0">
              <div class="col-md-10 mx-auto">
                <form [formGroup]="form">
                  <div class="form-group row" *ngIf="isLoginAsAdmin()">
                    <label class="col-md-3 col-form-label">
                      <div>Bypass API</div>
                    </label>
                    <div class="col-md-8">
                      <nz-select class="form-control" nzBorderless nzShowSearch [nzShowArrow]="true"
                        formControlName="bypassIsm">
                        <nz-option nzValue="0" nzLabel="No"></nz-option>
                        <nz-option nzValue="1" nzLabel="Yes"></nz-option>
                      </nz-select>
                    </div>
                  </div>

                  <div class="form-group row" *ngIf="isLoginAsAdmin()">
                    <label class="col-md-3 col-form-label">
                      <div>Source</div>
                    </label>
                    <div class="col-md-8">
                      <nz-select class="form-control" nzBorderless nzShowSearch [nzShowArrow]="true"
                        formControlName="source">
                        <nz-option nzValue="0" nzLabel="Online"></nz-option>
                        <nz-option nzValue="4" nzLabel="Walk In"></nz-option>
                        <nz-option nzValue="5" nzLabel="SleekFlow"></nz-option>
                      </nz-select>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Vehicle Type</div>
                    </label>
                    <div class="col-md-8">
                      <select class="form-control" formControlName="type">
                        <option value="Car">Car</option>
                        <option value="Motorcycle">Motorcycle</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Registration No<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" oninput="this.value = this.value.toUpperCase()"
                        (paste)="replaceRegistrationNoPasteValue($event)" (keypress)="keyPressAlphaNumeric($event)"
                        formControlName="vehicleNo" maxlength="8" placeholder="e.g: WMC1234" class="form-control"
                        [ngClass]="{'is-invalid': submitted &&  f.vehicleNo.errors}" required />
                      <div *ngIf="submitted && f.vehicleNo.errors" class="invalid-feedback">
                        <div *ngIf="f.vehicleNo.errors.required">Registration no is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>ID Type</div>
                    </label>
                    <div class="col-md-8">
                      <select class="form-control" (change)="idtypeOnChange($event.target.value)"
                        formControlName="idType">
                        <option value="NRIC">NRIC / MyKad</option>
                        <option value="Passport">Passport</option>
                        <option value="Army">Army</option>
                        <option value="Police">Police</option>
                        <option value="Company">Company</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row" *ngIf="!this.isCompanySelected() && !this.isNricSelected()">
                    <label class="col-md-3 col-form-label">
                      <div>Gender</div>
                    </label>
                    <div class="col-md-8">
                      <select class="form-control" formControlName="gender"
                        [ngClass]="{'is-invalid': submitted &&  f.gender.errors}">
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                      </select>
                      <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                        <div *ngIf="f.gender.errors.required">Gender is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" *ngIf="this.isCompanySelected()">
                    <label class="col-md-3 col-form-label">
                      <div>Company ID Type</div>
                    </label>
                    <div class="col-md-8">
                      <select class="form-control" (change)="companyIdtypeOnChange($event)"
                        formControlName="companyIdType">
                        <option value="old">Old Company Registration No</option>
                        <option value="new">New Company Registration No</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>ID<span class="require-asterisk">*</span></div>
                    </label>

                    <div class="col-md-8">

                      <input type="text" mask="{{idMask}}" [dropSpecialCharacters]="dropSpecialCharacters"
                        (keypress)="keyPressAlphaNumeric($event)" maxlength="14" formControlName="id"
                        placeholder='{{idTextBoxPlaceHolder}}' class="form-control capitalise" [ngClass]="{
                                  'is-invalid': submitted &&  f.id.errors
                                }" />
                      <label style="color: red;font-weight: bold;">(Key in as per identity card/passport no stated in
                        vehicle ownership certificate)</label>
                      <div *ngIf="submitted && f.id.errors" class="invalid-feedback">
                        <div *ngIf="f.id.errors.required">Id is required</div>
                        <div *ngIf="f.id.errors.mask">Invalid format</div>
                      </div>
                    </div>

                  </div>

                  <div style="text-align: center;" *ngIf="currentUser?.name != null">
                    <button (click)="SearchCustomer()" class="btn btn-primary">Search Customer</button>
                    <br />
                    <br />
                  </div>

                  <div class="form-group row" *ngIf="hideDob">
                    <label class="col-md-3 col-form-label">
                      <div>Date Of Birth<span class="require-asterisk">*</span></div>
                    </label>

                    <div class="col-md-8">
                      <nz-date-picker formControlName="dob" nzInputReadOnly nzShowToday="false"
                        [nzDisabledDate]="disabledEndDate" class="form-control" nzPlaceHolder="yyyy-mm-dd" [ngClass]="{
                        'is-invalid': submitted &&  f.dob.errors
                      }"></nz-date-picker>

                      <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                        <div *ngIf="f.dob.errors.required">Date of birth is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" *ngIf="this.isPassportSelected()">
                    <label class="col-md-3 col-form-label">
                      <div>Nationality<span class="require-asterisk">*</span></div>
                    </label>

                    <div class="col-md-8">
                      <nz-select nzShowSearch formControlName="nationality" class="form-control" [nzShowArrow]="true"
                        nzBorderless nzPlaceHolder="Select Nationality">
                        <nz-option *ngFor="let country of countryList" [nzLabel]="country.key"
                          [nzValue]="country.value">
                        </nz-option>
                      </nz-select>

                      <div *ngIf="submitted && f.nationality.errors" class="invalid-feedback">
                        <div *ngIf="f.nationality.errors.required">Nationality is required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Postcode<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        formControlName="postcode" placeholder="e.g: 68000" maxlength="5" class="form-control"
                        [ngClass]="{
                                'is-invalid': (submitted &&  f.postcode.errors) || f.postcode.errors?.invalidPostCode
                              }" />
                      <div *ngIf="f.postcode.errors" class="invalid-feedback">
                        <div *ngIf="f.postcode.errors?.invalidPostCode">Invalid postcode</div>

                      </div>

                      <div *ngIf="submitted && f.postcode.errors" class="invalid-feedback">
                        <div *ngIf="f.postcode.errors.required">Postcode is required</div>

                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Mobile Number<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" maxlength="12" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        formControlName="contactNo" placeholder="e.g: 018666666" class="form-control" [ngClass]="{
                              'is-invalid': submitted &&  f.contactNo.errors
                            }" />
                      <div *ngIf="submitted && f.contactNo.errors" class="invalid-feedback">
                        <div *ngIf="f.contactNo.errors.required">Mobile Number is required</div>
                        <div *ngIf="f.contactNo.errors.minlength">Mobile Number should be at least 10 digits</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Email<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" maxlength="50" placeholder="e.g: cindy@gmail.com" formControlName="email"
                        class="form-control" [ngClass]="{
                            'is-invalid': submitted &&  f.email.errors
                          }" email />
                      <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email is required</div>
                        <div *ngIf="f.email.errors.email">Invalid Email</div>
                      </div>
                    </div>
                  </div>

                </form>
                <div style="text-align: center;">
                  <button type="button" class="btn btn-block btn-outline-danger active"
                    (click)="onSubmit(true,true)"><strong>Next</strong></button>
                </div>
                <br />
                <p style="font-size: xx-small;">By clicking “Next”, you have read and
                  agree to our <a target="_blank" href="https://bmsroadtax.com/">Privacy Policy</a>. This site is
                  protected by reCAPTCHA and the Google
                  <a target="_blank" href="https://policies.google.com/privacy">Privacy Policy</a> and
                  <a target="_blank" href="https://policies.google.com/terms">Terms of Service</a> apply.</p>

              </div>
            </div>

            <div class="steps-content" *ngIf="current==1">
              <!-- <a target="_blank" style="color: red; font-weight: bold;"
                href="https://api.whatsapp.com/send?phone=60174372270">Customize your quotation following your budget?
                <label style="color: blue;font-weight: bold">
                  <== Click here</label> 
                </a>  -->
              <strong>
                Check our
                <label style="color: #40a9ff;" nz-popover nzPopoverTitle="" [nzPopoverContent]="excessContentTemplate"
                  nzPopoverPlacement="top">Services
                </label> here.
              </strong>

              <ng-template #excessContentTemplate>
                <div>
                  <strong>By purchasing this policy with us, the following insurance services are also
                    provided</strong><br />

                  - Asist on claims and refunds<br />
                  - Provide any further advice on product information<br />
                  - Response to any queries or complaints<br />
                  - Asist to check and resolve NCD Related issues for motor policy holders
                  <br />
                </div>
              </ng-template>


              <div class="row">
                <div class="col-sm-4" *ngIf="quotationResponseModel.zurich?.success">
                  <div class="card">
                    <div class="card-header">
                      <Strong>Comprehensive Coverage</Strong>
                    </div>
                    <div class="card-body">
                      <div style="text-align: center;">
                        <img style="width: 140PX;" src="assets/img/insurance/zurich.png" />
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="callout callout-info">
                            <small class="text-muted">Sum Insured</small>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.zurich?.suggestedPremium?.sumInsured | currency :'RM ':'symbol':'1.0' }}</strong>
                          </div>
                          <div class="callout callout-success">
                            <small class="text-muted">Basic Premium</small>
                            <br>
                            <strong
                              class="h5"><s>{{quotationResponseModel.zurich?.suggestedPremium?.basicPremium | currency :'RM ':'symbol':'1.2-2'}}</s><label
                                style="color: red;">({{-ncdPerc}}%
                                NCD)</label></strong>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.zurich?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          </div>
                        </div>
                      </div>
                      <br />
                      <nz-collapse nzGhost
                        *ngIf="this.isCarSelected() && !this.isCarThirdPartyFireAndTheftProductSelected()">
                        <nz-collapse-panel nzHeader="View Benefits" nzActive="false" nzDisabled="false">
                          <div class="bd-example">
                            <p *ngFor="let item of quotationResponseModel.zurich.benefits">{{item}}</p>
                          </div>
                        </nz-collapse-panel>
                      </nz-collapse>
                      <br />

                      <p style="font-size: xx-small;">
                        The insurance plan is underwritten by ZGIMB, a licensed insurer under the Financial Services Act
                        2013 and regulated by Bank Negara Malaysia. BMS RoadTax Services(003219451-V) is an
                        authorized distributor of ZGIMB.
                      </p>
                      <p style="font-size: xx-small;">The benefit(s) payable under this product is (are) protected
                        by PIDM up to limits. For more information,
                        please refer to <a target="_blank"
                          href="https://www.pidm.gov.my/getContentAsset/df69753b-0f66-45bd-a13c-31490c3ded0b/188ea75b-0100-4438-8f97-d79a01d9e0cd/Deposit-Insurance-System-Brochures.pdf?language=en">PIDM's
                          Takaful and Insurance Benefits Protection System brochure</a> on <a target="_blank"
                          href="https://www.zurich.com.my/">Zurich General Insurance Berhad</a>
                        website or <a target="_blank" href="https://www.pidm.gov.my/en">PIDM's</a> website.
                      </p>
                      <div style="min-height: 63px;"></div>
                      <div class="row">
                        <button (click)="next('ZURICH')" type="button" class="btn btn-block btn-outline-danger active"
                          aria-pressed="true">
                          <strong class="h6">Gross Premium</strong>
                          <br />
                          <strong
                            class="h4">{{quotationResponseModel.zurich?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          <br />
                          <strong class="h6">I WANT THIS!</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4" *ngIf="quotationResponseModel.generali?.success">
                  <div class="card">
                    <div class="card-header">
                      <Strong>{{generaliPlanName}} Coverage</Strong>
                    </div>
                    <div class="card-body">
                      <div style="text-align: center;">
                        <img style="width: 115PX;" src="assets/img/insurance/generali.png" />
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="callout callout-info" *ngIf="this.isCarSelected() ">
                            <small class="text-muted">Sum Insured</small>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.generali?.suggestedPremium?.sumInsured | currency :'RM ':'symbol':'1.0' }}</strong>
                          </div>
                          <div class="callout callout-success">
                            <small class="text-muted">Basic Premium</small>
                            <br>
                            <strong
                              class="h5"><s>{{quotationResponseModel.generali?.suggestedPremium?.basicPremium | currency :'RM ':'symbol':'1.2-2'}}</s><label
                                style="color: red;">({{-this.quotationResponseModel.generali?.suggestedPremium.ncdPerc}}%
                                NCD)</label></strong>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.generali?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          </div>
                        </div>
                      </div>
                      <br />


                      <nz-collapse nzGhost
                        *ngIf="this.isCarSelected() && !this.isCarThirdPartyFireAndTheftProductSelected()">
                        <nz-collapse-panel nzHeader="View Benefits" nzActive="false" nzDisabled="false">
                          <div class="bd-example">
                            <p *ngFor="let item of quotationResponseModel.generali.benefits">{{item}}</p>
                          </div>
                        </nz-collapse-panel>
                      </nz-collapse>
                      <br />
                      <p style="font-size: xx-small;">
                        This policy is underwritten by Generali Insurance Malaysia Berhad. 'BMS' has been appointed
                        by Generali Insurance Malaysia Berhad to act as an agent. For any claims assistance,
                        complaints or product information, please contact us at <a target="_blank"
                          style="color:#40a9ff; font-weight: bold;"
                          href="https://api.whatsapp.com/send?phone=60174372270">60174372270</a>
                      </p>
                      <div style="min-height: 129px;"></div>
                      <div class="row">
                        <button (click)="next('GENERALI')" type="button" class="btn btn-block btn-outline-danger active"
                          aria-pressed="true">
                          <strong class="h6">Gross Premium</strong>
                          <br />
                          <strong
                            class="h4">{{quotationResponseModel.generali?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          <br />
                          <strong class="h6">I WANT THIS!</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4" *ngIf="quotationResponseModel.kurnia?.success">
                  <div class="card">
                    <div class="card-header">
                      <Strong>{{kurniaPlanName}} Coverage</Strong>
                    </div>
                    <div class="card-body">
                      <div style="text-align: center;">
                        <img style="width: 257PX;" src="assets/img/insurance/kurnia.png" />
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="callout callout-info">
                            <small class="text-muted">Sum Insured</small>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.kurnia?.suggestedPremium?.sumInsured | currency :'RM ':'symbol':'1.0' }}</strong>
                          </div>
                          <div class="callout callout-success">
                            <small class="text-muted">Basic Premium</small>
                            <br>
                            <strong
                              class="h5"><s>{{quotationResponseModel.kurnia?.suggestedPremium?.basicPremium | currency :'RM ':'symbol':'1.2-2'}}</s><label
                                style="color: red;">({{-ncdPerc}}%
                                NCD)</label></strong>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.kurnia?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          </div>
                        </div>
                      </div>
                      <div style="text-align: center;">
                        <strong class="blinking">Free Gift - Inverted umbrella for premium above RM1,000</strong><br />
                      </div>
                      <nz-collapse nzGhost
                        *ngIf="this.isCarSelected() && !this.isCarThirdPartyFireAndTheftProductSelected()">
                        <nz-collapse-panel nzHeader="View Benefits" nzActive="false" nzDisabled="false">
                          <div class="bd-example">
                            <p *ngFor="let item of quotationResponseModel.kurnia.benefits">{{item}}</p>
                          </div>
                        </nz-collapse-panel>
                      </nz-collapse>
                      <br />
                      <p style="font-size: xx-small;">Brilliant Management Services (BMS) is an authorized distributor
                        of Liberty General
                        Insurance Berhad</p>
                      <p style="font-size: xx-small;"> The benefit(s) payable under this eligible policy is
                        protected by PIDM up to limits. Please refer to PIDM’s TIPS Brochure or contact Liberty
                        General Insurance Berhad or <a target="_blank" href="https://www.pidm.gov.my/en">PIDM</a>.


                      </p>
                      <div style="min-height: 85px;"></div>
                      <div class="row">
                        <button (click)="next('KURNIA')" type="button" class="btn btn-block btn-outline-danger active"
                          aria-pressed="true">
                          <strong class="h6">Gross Premium</strong>
                          <br />
                          <strong
                            class="h4">{{quotationResponseModel.kurnia?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          <br />
                          <strong class="h6">I WANT THIS!</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4" *ngIf="quotationResponseModel.chubb?.success">
                  <div class="card">
                    <div class="card-header">
                      <Strong>Comprehensive Coverage</Strong>
                    </div>
                    <div class="card-body">
                      <div style="text-align: center;">
                        <img style="width: 240px;margin-top:40px;margin-bottom:40px" src="assets/img/insurance/chubb.png" />
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="callout callout-info">
                            <small class="text-muted">Market Value (ISM-ABI recommended)</small>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.chubb?.vehicleValueInfo?.marketValue | currency :'RM ':'symbol':'1.0' }}</strong>
                          </div>
                          <div class="callout callout-info">
                            <small class="text-muted">Sum Insured</small>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.chubb?.suggestedPremium?.sumInsured | currency :'RM ':'symbol':'1.0' }}</strong>
                          </div>
                          <div class="callout callout-success">
                            <small class="text-muted">Basic Premium</small>
                            <br>
                            <strong
                              class="h5"><s>{{quotationResponseModel.chubb?.suggestedPremium?.basicPremium | currency :'RM ':'symbol':'1.2-2'}}</s><label
                                style="color: red;">({{-ncdPerc}}%
                                NCD)</label></strong>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.chubb?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          </div>
                        </div>
                      </div>
                      <div style="text-align: center;">
                        <strong class="blinking">24/7 Unlimited Towing Service</strong><br />
                        <strong class="blinking">Free Touch ‘n Go Cashback. T&C Apply</strong><br />

                        • RM30 with premium above RM1,000
                      </div>
                      <nz-collapse nzGhost
                        *ngIf="this.isCarSelected() && !this.isCarThirdPartyFireAndTheftProductSelected()">
                        <nz-collapse-panel nzHeader="View Benefits" nzActive="false" nzDisabled="false">

                          <div class="bd-example">
                            <p *ngFor="let item of quotationResponseModel.chubb.benefits">{{item}}</p>
                          </div>
                          <p style="font-size: xx-small;"><strong>*This is a brief description and is non-exhaustive.
                              The benefits and coverage may change according to the plan you choose in the next page.
                              Please refer to the Policy Wording for the full details of benefits, exclusions, terms &
                              conditions before proceed to make payment.</strong></p>
                        </nz-collapse-panel>
                      </nz-collapse>
                      <br />
                      <p style="font-size: xx-small;">(1) Eligibility: The insured must be the lawful owner of the
                        vehicle, is 18 years old and above, and holds a valid Malaysian driving license.</p>
                      <p style="font-size: xx-small;">(2) Note: You are advised to insure your vehicle at the
                        appropriate current market value (MV). If the vehicle is under-insured, the claim payment will
                        be lesser than the sum insured, and you must bear the balance of the loss in proportion to the
                        difference between the MV and the sum insured. If the vehicle is over-insured, the claim payment
                        offered will not be the sum insured but at the vehicle’s MV only.
                        Where the sum insured is on an agreed value basis, payment of claims in the event of (1) actual
                        total loss, (2) the vehicle being beyond economical repair or (3) theft will be based on the
                        agreed value stated in the policy.
                      </p>
                      <p style="font-size: xx-small;">If the vehicle’s market value recommended by the ISM-ABI system is
                        lower than the balance amount outstanding on your hire-purchase or any other financing loan on
                        vehicle, please contact Chubb’s customer service at (1800-88-3226) or your servicing Chubb
                        intermediary to discuss the availability of insurance to cover the difference between the market
                        value and outstanding loan.</p>
                      <p style="font-size: xx-small;">The policy is <strong>underwritten by Chubb Insurance Malaysia
                          Berhad</strong>, Registration Number: 197001000564 (“Chubb”). Chubb is licensed under the
                        Financial Services Act 2013 and regulated by Bank Negara Malaysia. This policy is
                        <strong>distributed by Lim Siew Tin</strong>, a registered agent of Chubb, on the
                        <strong>platform owned and operated by BMS ROADTAX e-platform.</strong></p>
                      <p style="font-size: xx-small;">The benefit(s) payable under eligible certificate/policy/product
                        is(are) protected by PIDM up to limits. Please refer to PIDM’s TIPS Brochure or contact <a
                          target="_blank" href="https://www.chubb.com/">Chubb Insurance Malaysia Berhad</a> or <a
                          target="_blank" href="https://www.pidm.gov.my/en">PIDM's</a>.</p>
                      <div style="min-height: 10px;"></div>
                      <div class="row">
                        <button (click)="next('CHUBB')" type="button" class="btn btn-block btn-outline-danger active"
                          aria-pressed="true">
                          <strong class="h6">Gross Premium</strong>
                          <br />
                          <strong
                            class="h4">{{quotationResponseModel.chubb?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          <br />
                          <strong class="h6">I WANT THIS!</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4" *ngIf="quotationResponseModel.tune?.success">
                  <div class="card">
                    <div class="card-header">
                      <Strong>Comprehensive Coverage</Strong>
                    </div>
                    <div class="card-body">
                      <div style="text-align: center;">
                        <img style="width: 110PX;" src="assets/img/insurance/tune.png" />
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="callout callout-info">
                            <small class="text-muted">Sum Insured</small>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.tune?.suggestedPremium?.sumInsured | currency :'RM ':'symbol':'1.0' }}</strong>
                          </div>
                          <div class="callout callout-success">
                            <small class="text-muted">Basic Premium</small>
                            <br>
                            <strong
                              class="h5"><s>{{quotationResponseModel.tune?.suggestedPremium?.basicPremium | currency :'RM ':'symbol':'1.2-2'}}</s><label
                                style="color: red;">({{-ncdPerc}}%
                                NCD)</label></strong>
                            <br>
                            <strong
                              class="h4">{{quotationResponseModel.tune?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          </div>
                        </div>
                      </div>

                      <nz-collapse nzGhost>
                        <nz-collapse-panel nzHeader="View Benefits" nzActive="false" nzDisabled="false">

                          <div class="bd-example">
                            <p *ngFor="let item of quotationResponseModel.tune.benefits">{{item}}</p>
                          </div>
                          <p style="font-size: xx-small;"></p>
                        </nz-collapse-panel>
                      </nz-collapse>
                      <br />



                      <p style="font-size: xx-small;">Underwritten by Tune Insurance Malaysia Berhad
                        Company No: 197601004719 (30686-K).
                        Distributed by "Passion Agency” as the authorised agent registered with PIAM</p>


                      <div style="text-align: center;"><img style="width: 80px;padding-bottom: 10px"
                          src="assets/img/pidm.png" />
                      </div>
                      <p style="font-size: xx-small;">Tune Insurance Malaysia Berhad is a member of PIDM.
                        The benefit(s) payable under eligible policy is(are) protected by PIDM up to limits. Please
                        refer to PIDM’s TIPS Brochure or contact
                        <a target="_blank" href="https://www.tuneprotect.com/">Tune Insurance Malaysia Berhad</a> or
                        PIDM
                        (visit <a target="_blank" href="https://www.pidm.gov.my/en">www.pidm.gov.my</a>). Refer to <a
                          href="{{getTuneProductDisclosureLink}}" target="_blank">Product Disclosure Sheet</a>
                        & <a href="{{getTunePolicyWording}}" target="_blank">Policy Wording</a> for more details.</p>

                      <div style="min-height: 34px;"></div>
                      <div class="row">
                        <button (click)="next('TUNE')" type="button" class="btn btn-block btn-outline-danger active"
                          aria-pressed="true">
                          <strong class="h6">Gross Premium</strong>
                          <br />
                          <strong
                            class="h4">{{quotationResponseModel.tune?.suggestedPremium?.grossPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                          <br />
                          <strong class="h6">I WANT THIS!</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <button type="button" class="btn btn-block btn-outline-danger active"
                  (click)="pre()"><strong>Back</strong></button>
              </div>
            </div>

            <div class="steps-content" *ngIf="current==2">
              <div *ngIf="this.isChubbSelected()">
                <div style="text-align: center;">
                  <strong>Underwritten by</strong>
                  <img style="width: 240px;padding-left: 10px;padding-right: 10px;" src="assets/img/insurance/chubb.png" />
                  <strong>Distributed by Lim Siew Tin</strong>
                </div>
                  <br/>

              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label">
                  <strong>Current Plan: </strong>

                </label>
                <div class="col-md-5">

                  <select
                    *ngIf="quotationResponseModel.generali?.insurancePlan?.length > 0 && this.isGeneraliSelected()"
                    [(ngModel)]="selectedProductCode" (change)="planOnChange($event)" class="form-control">
                    <option *ngFor="let plan of quotationResponseModel.generali.insurancePlan" value="{{plan.code}}">
                      {{plan.description}}
                    </option>
                  </select>

                  <select *ngIf="quotationResponseModel.kurnia?.insurancePlan?.length > 0 && this.isKurniaSelected()"
                    [(ngModel)]="selectedProductCode" (change)="planOnChange($event)" class="form-control">
                    <option *ngFor="let plan of quotationResponseModel.kurnia.insurancePlan" value="{{plan.code}}">
                      {{plan.description}}
                    </option>
                  </select>

                  <select *ngIf="quotationResponseModel.zurich?.insurancePlan?.length > 0 && this.isZurichSelected()"
                    [(ngModel)]="selectedProductCode" (change)="planOnChange($event)" class="form-control">
                    <option *ngFor="let plan of quotationResponseModel.zurich.insurancePlan" value="{{plan.code}}">
                      {{plan.description}}
                    </option>
                  </select>

                  <select *ngIf="quotationResponseModel.chubb?.insurancePlan?.length > 0 && this.isChubbSelected()"
                    [(ngModel)]="selectedProductCode" (change)="planOnChange($event)" class="form-control">
                    <option *ngFor="let plan of quotationResponseModel.chubb.insurancePlan" value="{{plan.code}}">
                      {{plan.description}}
                    </option>
                  </select>

                  <select *ngIf="quotationResponseModel.tune?.insurancePlan?.length > 0 && this.isTuneSelected()"
                    [(ngModel)]="selectedProductCode" (change)="planOnChange($event)" class="form-control">
                    <option *ngFor="let plan of quotationResponseModel.tune.insurancePlan" value="{{plan.code}}">
                      {{plan.description}}
                    </option>
                  </select>

                </div>

              </div>


              <nz-collapse nzAccordion>
                <nz-collapse-panel nzHeader="Policy & Vehicle Info" nzActive="true" nzDisabled="false">
                  Insurance Company :
                  <strong>{{getInsuranceCompanyFullName()}}
                  </strong>
                  <br />
                  Policy Period : <strong>{{policyStartDate}}</strong> To <strong>{{policyEndDate}} </strong>

                  <div *ngIf="this.isCarSelected()">
                    <div *ngIf="vehicleType=='saloon'">
                      Vehicle Type : <strong>Saloon</strong>
                    </div>
                    <div *ngIf="vehicleType != 'saloon'">
                      Vehicle Type : <strong>Non-Saloon</strong>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-5"> Registration No :
                      <strong>{{verifyVehicleReponseModel.vehicleInfo.registrationNo}}</strong></div>
                    <div class="col-md-5"> Capacity :
                      <strong>{{capacity}}</strong></div>
                  </div>
                  <div class="row">
                    <div class="col-md-5"> Brand : <strong>{{brand}}</strong>
                    </div>
                    <div class="col-md-5"> Model : <strong>{{model}}</strong>
                    </div>
                  </div>
                  <div class="row" *ngIf="this.isTuneSelected()">
                    <div class="col-md-9"> Variant :
                      <strong>{{verifyVehicleReponseModel.vehicleInfo.variant}}</strong></div>
                  </div>
                  <div class="row">
                    <div class="col-md-5"> Manufacturer Year :
                      <strong>{{verifyVehicleReponseModel.vehicleInfo.manufacturingYear}}</strong></div>
                  </div>
                  <br />
                  <form [formGroup]="engineTypeForm">
                    <div class="form-group row" *ngIf="this.isKurniaSelected()">

                      <label class="col-md-2 col-form-label">
                        <strong>Engine Type: </strong>
                      </label>
                      <div class="col-md-5">
                        <select class="form-control" formControlName="engineType">
                          <option value="F">Fuel</option>
                          <option value="E">Electric</option>
                          <option value="H">Hybrid</option>
                          <option value="P">Plug In Hybrid</option>
                        </select>
                      </div>

                    </div>
                  </form>
                </nz-collapse-panel>
              </nz-collapse>
              <br />
              <div class="row">
                <div class="col-md-6" *ngIf="displaySumInsured()">
                  <nz-card nzType="inner" nzTitle="Vehicle Sum Insured">
                    <form [formGroup]="vehicleform">
                      <div class="form-group row">
                        <label class="col-md-10 col-form-label">
                          <nz-input-number type="number" formControlName="sumInsured"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57" [nzStep]="500"
                            [nzMax]="maxAgreedValue" [nzMin]="minAgreedValue" class="form-control" class="form-control"
                            [ngClass]="{
                            'is-invalid': submitted &&  vf.sumInsured.errors
                          }"></nz-input-number>
                          <br />
                          <strong><em>Range: RM {{minAgreedValue | number}} - RM
                              {{maxAgreedValue| number}}</em></strong>
                          <br />
                          <strong *ngIf="this.isChubbSelected()"><em>Market Value (ISM-ABI recommended): RM
                              {{quotationResponseModel.chubb?.vehicleValueInfo?.marketValue | number}} </em></strong>
                        </label>
                      </div>
                    </form>
                  </nz-card>

                  <br />
                </div>

                <div class="col-md-6" *ngIf="this.displayWindScreen() ">
                  <nz-card nzType="inner" nzTitle="Windscreen" [nzExtra]="windScreen">
                    <div class="form-group row">
                      <label class="col-md-5 col-form-label">
                        <div>Sum Insured</div>
                      </label>
                      <div class="col-md-5">
                        <form [formGroup]="windScreenform">
                          <nz-input-number type="number" formControlName="windScreenSumInsured"
                            (ngModelChange)="onWindScreenSumInsuredChanged()"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            class="form-control text-right" [ngClass]="{
                                    'is-invalid': submitted &&  wsf.windScreenSumInsured.errors
                                  }" [nzMax]="100000" [nzMin]="500" [nzStep]="100"></nz-input-number>
                        </form>
 
                      </div>
                      <label class="col-md-10 col-form-label">
                        <strong><em>Range: RM 500 - RM 100,000</em> (Optional)</strong>
                      </label>
                    </div>

                  </nz-card>

                  <ng-template #windScreen>
                    <div class="row">
                      <div class="col-md-9  text-right">
                        <strong>+{{windScreenPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                      </div>
                      <div class="col-md-1  text-right">
                        <label nz-checkbox [(ngModel)]="isWindScreenChecked" [disabled]="isWindscreenDisabled"
                          (ngModelChange)="onWindScreenChecked($event)">
                        </label>
                      </div>
                    </div>
                  </ng-template>
                  <br />
                </div>
              </div>

              <div class="row">

                <div class="col-md-6">

                  <nz-card nzType="inner" nzTitle="{{roadTaxType}} Road Tax" [nzExtra]="roadTaxOption">
                    <strong>Renewal Amount :</strong> {{roadTaxAmount | currency :'RM ':'symbol':'1.2-2'}}
                    <br />
                    <strong>Tenure :</strong> 1 Year
                    <br />
                    <div *ngIf="showRoadTaxRunnerService">
                      <strong>Runner to JPJ Service :
                      </strong>{{roadTaxRunnerService | currency :'RM ':'symbol':'1.2-2'}}
                      <br />
                    </div>


                    <div *ngIf="showRoadTaxDeliveryService && 
                        (this.isCompanySelected() || this.isPassportSelected()) && 
                        !this.roadTaxSettings.deliveryFeeWaivedWithInsurance">
                      <strong>Courier Fee : </strong>{{roadTaxDeliveryService | currency :'RM ':'symbol':'1.2-2'}}
                      <br />
                    </div>

                    <div *ngIf="showRoadTaxDeliveryService && 
                    (!this.isCompanySelected()  &&  !this.isPassportSelected()) ">
                      <strong>Courier Fee : </strong>
                      <label> {{roadTaxDeliveryService | currency :'RM ':'symbol':'1.2-2'}}</label>
                      <br />
                    </div>

                    <div *ngIf="this.isCarSelected() && this.verifyVehicleReponseModel.vehicleInfo?.isWagon">
                      <br />

                      <div class="row">
                        <div style="margin-right: 11px;margin-left: 15px;">
                          <strong style="margin-right: 30px;">Type :</strong>
                        </div>
                        <div>
                          <form [formGroup]="isSaloonForm">

                            <nz-radio-group formControlName="isSaloon" (ngModelChange)="vehicleTypeOnChange($event)">

                              <label nz-radio nzValue="true">
                                <strong>Saloon</strong>
                              </label>
                              <label nz-radio nzValue="false">
                                <strong>Non-Saloon</strong>
                              </label>

                            </nz-radio-group>
                          </form>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="this.isNricSelected()">
                      <strong style="margin-right: 30px;">Road Tax :</strong>
                      <nz-radio-group [nzDisabled]="disablePhysicalRoadTax" [(ngModel)]="roadTaxType"
                        (ngModelChange)="onRoadTaxTypeClick($event)">
                        <div class="row">
                          <label nz-radio nzValue="Physical">
                            <strong>Digital + Physical</strong> <label></label>
                          </label>
                          <label nz-radio nzValue="Digital">
                            <strong>Digital Only</strong>
                          </label>
                        </div>
                      </nz-radio-group>

                    </div>

                    <br />
                    <div *ngIf="this.isDigitalRoadTaxSelected()">
                      <strong style="color: red;">Once renewed the digital Road Tax will be show in MyJPJ APP and
                        verification receipt will be sent as proof.</strong>
                    </div>
                    <div *ngIf="!this.isDigitalRoadTaxSelected()">
                      <strong style="color: red;">Our staff will share you the courier[ETA: 2-3 workings day]
                        detail once payment done.</strong>
                    </div>
                  </nz-card>

                  <ng-template #roadTaxOption>
                    <div class="row">
                      <div class="col-md-9 text-right">
                        <strong>+{{getRoadTaxAmount() + getRoadTaxDeliveryService() + getRoadTaxRunnerService() | currency :'RM ':'symbol':'1.2-2'}}</strong>
                      </div>
                      <div class="col-md-1 text-right">
                        <label nz-checkbox [(ngModel)]="isRoadTaxChecked"
                          (ngModelChange)="onRoadTaxChecked($event)"></label>
                      </div>
                    </div>
                  </ng-template>

                  <br />
                </div>

                <div class="col-md-6" *ngIf="this.displayAllDrivers() && this.isCarSelected()">
                  <nz-card nzType="inner" nzTitle="{{allDriverTitle}}" [nzExtra]="allDrivers">
                    <div *ngIf="!this.isGeneraliSelected()">
                      Cover any authorised drivers. <strong>(Optional)</strong>
                      <br />
                    </div>
                    <div *ngIf="this.isGeneraliSelected()">
                      - Waiver of Excess for Authorised Driver <br />
                      - Limited Act of God - RM10,000 <br />
                      - Additional Cash Payout - RM5,000 <br />
                      <br />
                      <strong>(Optional)</strong>
                      <br />
                    </div>
                  </nz-card>

                  <ng-template #allDrivers>
                    <div class="row">
                      <div class="col-md-9  text-right">
                        <strong>+ {{allDriverPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                      </div>
                      <div class="col-md-1  text-right">
                        <label nz-checkbox [(ngModel)]="isAllDriversChecked" [disabled]="isAllDriversDisabled"
                          (ngModelChange)="onAllDriversChecked($event)">
                        </label>
                      </div>
                    </div>
                  </ng-template>
                  <br />
                </div>
                <div class="col-md-6" *ngIf="displayAllRiders()">
                  <nz-card nzType="inner" nzTitle="All Riders" [nzExtra]="allRiders">
                    <div>
                      Cover any authorised riders. <strong *ngIf="!isAllRiderCompulsory">(Optional)</strong>
                      <br />
                    </div>
                  </nz-card>

                  <ng-template #allRiders>
                    <div class="row">
                      <div class="col-md-9  text-right">
                        <strong>+ {{allRiderPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                      </div>
                      <div class="col-md-1  text-right">
                        <label nz-checkbox [(ngModel)]="isAllRidersChecked" [disabled]="isAllRidersDisabled"
                          (ngModelChange)="onAllRidersChecked($event)">
                        </label>
                      </div>
                    </div>
                  </ng-template>
                  <br />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6" *ngIf="this.displaySpecialPerils() ">
                  <nz-card nzType="inner" nzTitle="Special Perils" [nzExtra]="specialPerils">
                    Cover damages caused by flood, landslide & other natural disasters. <strong>(Optional)</strong>
                  </nz-card>

                  <ng-template #specialPerils>
                    <div class="row">
                      <div class="col-md-9  text-right">
                        <strong>+{{specialPerilsPremium | currency :'RM ':'symbol':'1.2-2'}}</strong>
                      </div>
                      <div class="col-md-1 text-right">
                        <label nz-checkbox [(ngModel)]="isSpecialPerilsChecked" [disabled]="isSpecialPerilsDisabled"
                          (ngModelChange)="onSpecialPerilsChecked($event,true,true)">
                        </label>
                      </div>
                    </div>
                  </ng-template>
                  <br />
                </div>

                <div class="col-md-6">

                  <nz-card nzType="inner" nzTitle="Legal Liability of Passenger (LLOP)" [nzExtra]="llop"
                    *ngIf="this.displayLLOP() ">
                    Coverage for liability due to negligence of your passengers to public.
                    <strong>(Optional)</strong>

                  </nz-card>

                  <ng-template #llop>
                    <div class="row">
                      <div class="col-md-9  text-right">
                        <strong>+ {{7.5 | currency :'RM ':'symbol':'1.2-2'}}</strong>
                      </div>
                      <div class="col-md-1 text-right">
                        <label nz-checkbox [(ngModel)]="isLlopChecked" (ngModelChange)="onLlopChecked($event)"
                          [disabled]="isLlopDisabled">
                        </label>
                      </div>
                    </div>
                  </ng-template>
                  <br />
                </div>
              </div>
              <div *ngIf="this.isChubbSelected()">
                <nz-card>

                  Any premium or quotes, if shown in this document is an estimate and is subject to the procedures of
                  review and approval by the authorized Underwriters of Chubb Insurance Malaysia Berhad. It shall not,
                  under any circumstances, be considered as confirmation of risk acceptance.

                </nz-card>
                <br />
              </div>
              <nz-collapse nzAccordion>
                <nz-collapse-panel nzHeader="Summary" nzActive="true" nzDisabled="false">
                  <nz-table [nzData]="['']" [nzShowPagination]="false">
                    <thead>
                    </thead>
                    <tbody>
                      <tr *ngIf="displaySumInsured()">
                        <td style="border-bottom: 1pt solid"><strong>Sum Insured</strong></td>
                        <td style="border-bottom: 1pt solid;text-align: right;min-width: 100px">
                          {{sumInsuredAmount  | currency :'RM ':'symbol':'1.2-2'}}
                        </td>
                      </tr>
                      <tr>
                        <td style="border-bottom: none;"><strong>Basic Premium</strong></td>
                        <td style="border-bottom: none;;text-align: right;">
                          {{basicPremium | currency :'RM ':'symbol':'1.2-2'}}
                        </td>
                      </tr>
                      <tr *ngIf="isAllRidersChecked">
                        <td style="border-bottom: none"><strong>All Riders</strong></td>
                        <td style="border-bottom: none;text-align: right;">
                          {{allRiderPremium | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="this.isMotorcycleSelected()">
                        <td style="border-bottom: none;"><strong>Loading</strong></td>
                        <td style="border-bottom: none;;text-align: right;">
                          {{loading | currency :'RM ':'symbol':'1.2-2'}}
                        </td>
                      </tr>
                      <tr>
                        <td style="border-bottom: none;"><strong>No Claim Discount(NCD) -
                            {{ncdPerc}}%</strong></td>
                        <td style="border-bottom: none;;text-align: right;">
                          <strong style="color: red;">- {{ncdDiscount | currency :'RM ':'symbol':'1.2-2'}}</strong>
                        </td>
                      </tr>
                      @if(this.isChubbSelected())
                      {
                      <tr>
                        <td style="border-bottom: none;"><strong>Plan Premium</strong></td>
                        <td style="border-bottom: none;;text-align: right;">
                          {{planPremium | currency :'RM ':'symbol':'1.2-2'}}
                        </td>
                      </tr>
                      }
                      <tr
                        *ngIf=" isAllDriversChecked || isSpecialPerilsChecked || isLltpChecked || isLlopChecked || isWindScreenChecked">
                        <td style="border-bottom: none"><strong>Extra Coverage</strong></td>
                        <td style="border-bottom: none;text-align: right;">
                          {{extraCoverage | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="isAllDriversChecked">
                        <td style="border-bottom: none"> - {{allDriverTitle}}
                          <strong *ngIf="isAllDriversDisabled && this.isKurniaSelected()" style="color:red;">(Inclusive
                            in plan)</strong></td>
                        <td style="border-bottom: none;text-align: right;">
                          {{allDriverPremium | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="isSpecialPerilsChecked">
                        <td style="border-bottom: none"> - Special Perils</td>
                        <td style="border-bottom: none;text-align: right;">
                          {{specialPerilsPremium | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="isLltpChecked">
                        <td style="border-bottom: none"> - LLTP</td>
                        <td style="border-bottom: none;text-align: right;">
                          {{lltpPremium | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="isLlopChecked">
                        <td style="border-bottom: none"> - LLOP</td>
                        <td style="border-bottom: none;text-align: right;">
                          {{llopPremium | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="isWindScreenChecked">
                        <td style="border-bottom: none"> - Wind Screen <strong>(Sum Insured:
                            {{windScreenform.get('windScreenSumInsured').value| number : '1.2-2'}})</strong></td>
                        <td style="border-bottom: none;text-align: right;">
                          {{windScreenPremium | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1pt solid"></td>
                        <td style="border-bottom: 1pt solid;text-align: right;">
                        </td>
                      </tr>
                      <tr>
                        <td style="border-bottom: none;">
                          <strong>Gross Premium </strong><br />
                        </td>
                        <td style="border-bottom: none;;text-align: right;">
                          {{grossPremium | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="!this.commissionSettings.hideCommission">
                        <td style="border-bottom: none;"> <strong>Commission Included (10%)</strong></td>
                        <td style="border-bottom: none;;text-align: right;">
                          {{commission  | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: none;"> <strong>Service Tax (8%)</strong></td>
                        <td style="border-bottom: none;;text-align: right;">
                          {{serviceTax | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: none;"> <strong>Stamp Duty</strong></td>
                        <td style="border-bottom: none;;text-align: right;">
                          {{stampDuty  | currency :'RM ':'symbol':'1.2-2'}}
                        </td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1pt solid"></td>
                        <td style="border-bottom: 1pt solid;text-align: right;">
                        </td>
                      </tr>
                      <tr>
                        <td style="border-bottom: none;">
                          <strong>Total Premium </strong><br />
                        </td>
                        <td style="border-bottom: none;;text-align: right;">
                          {{totalPremium | currency :'RM ':'symbol':'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="isRoadTaxChecked">
                        <td style="border-bottom: none;"> <strong>Road Tax </strong><strong style="color: red;"> (1
                            Year)</strong></td>
                        <td style="border-bottom:  none;text-align: right;">
                          {{roadTaxAmount   | currency :'RM ':'symbol':'1.2-2'}}
                        </td>
                      </tr>

                      <tr *ngIf="isRoadTaxChecked && showRoadTaxDeliveryService &&
                      (!this.isCompanySelected() && !this.isPassportSelected())">
                        <td style="border-bottom: none;"> - Courier Fee </td>
                        <!-- <td style="border-bottom:  none;text-align: right;">
                          <span> {{roadTaxDeliveryService | currency :'RM ':'symbol':'1.2-2'}}</span></td> -->
                        <td style="border-bottom:  none;text-align: right;">
                          <span style="text-decoration: line-through">
                            {{this.roadTaxSettings.deliveryFeeWithInsurance | currency :'RM ':'symbol':'1.2-2'}}</span>
                          <span> {{0 | currency :'RM ':'symbol':'1.2-2'}}</span></td>
                      </tr>
                      <tr *ngIf="isRoadTaxChecked && showRoadTaxDeliveryService &&
                      (this.isCompanySelected() || this.isPassportSelected())">
                        <td style="border-bottom: none;"> - Courier Fee </td>
                        <td style="border-bottom:  none;text-align: right;"
                          *ngIf="!this.roadTaxSettings.deliveryFeeWaivedWithInsurance">
                          <span> {{roadTaxDeliveryService | currency :'RM ':'symbol':'1.2-2'}}</span></td>
                        <td style="border-bottom:  none;text-align: right;"
                          *ngIf="this.roadTaxSettings.deliveryFeeWaivedWithInsurance">
                          <span style="text-decoration: line-through">
                            {{this.roadTaxSettings.deliveryFeeWithInsurance | currency :'RM ':'symbol':'1.2-2'}}</span>
                          <span> {{0 | currency :'RM ':'symbol':'1.2-2'}}</span></td>
                      </tr>

                      <tr *ngIf="isRoadTaxChecked && showRoadTaxRunnerService">
                        <td style="border-bottom: none;"> - Physical Road Tax Runner Service </td>
                        <td style="border-bottom:  none;text-align: right;"
                          *ngIf="!this.roadTaxSettings.runnerFeeWaivedWithInsurance">
                          <span> {{roadTaxRunnerService | currency :'RM ':'symbol':'1.2-2'}}</span></td>

                        <td style="border-bottom:  none;text-align: right;"
                          *ngIf="this.roadTaxSettings.runnerFeeWaivedWithInsurance">
                          <span style="text-decoration: line-through">
                            {{this.roadTaxSettings.runnerFeeWithInsurance | currency :'RM ':'symbol':'1.2-2'}}</span>
                          <span> {{0 | currency :'RM ':'symbol':'1.2-2'}}</span></td>
                      </tr>

                      <tr *ngIf="isRoadTaxChecked  && this.isDigitalRoadTaxSelected()">
                        <td style="border-bottom: none;"> - Digital Road Tax Service Charge </td>
                        <td style="border-bottom:  none;text-align: right;">
                          <span *ngIf="this.roadTaxSettings.serviceChargeWaivedWithInsurance"
                            style="text-decoration: line-through"> {{9 | currency :'RM ':'symbol':'1.2-2'}}</span>
                          <span> {{roadTaxServiceCharge | currency :'RM ':'symbol':'1.2-2'}}</span></td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1pt solid"></td>
                        <td style="border-bottom: 1pt solid;text-align: right;">
                        </td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1pt solid"> <strong>Total Amount</strong></td>
                        <td style="border-bottom: 1pt solid;text-align: right;">
                          <strong>{{totalAmount| currency :'RM ':'symbol':'1.2-2'}}</strong></td>
                      </tr>
                    </tbody>
                  </nz-table>
                </nz-collapse-panel>
              </nz-collapse>
              <br />

              <nz-card *ngIf="this.isGeneraliSelected() " style="background-color: #F0D5D2 !important;;" nzType="inner">
                <strong>Compulsory Excess / Excess Damage Claims
                  <label style="color: red;" nz-popover nzPopoverTitle="" [nzPopoverContent]="excessContentTemplate"
                    nzPopoverPlacement="top">(What's this?)
                  </label>
                </strong>

                <div class="row">

                  <div class="col-6">
                    Compulsory Excess
                  </div>
                  <div class="col-3 text-right">
                    <strong>
                      {{quotationResponseModel.generali?.suggestedPremium?.compulsoryExcess | currency :'RM ':'symbol':'1.0' }}</strong>
                  </div>


                </div>
                <div class="row" *ngIf="this.isCarSelected() ">
                  <div class="col-6">
                    Excess Coverage Claims
                  </div>
                  <div class="col-3 text-right">
                    <strong>
                      {{quotationResponseModel.generali?.suggestedPremium?.excess | currency :'RM ':'symbol':'1.0' }}</strong>
                  </div>
                </div>
              </nz-card>
              <ng-template #excessContentTemplate>
                <div>
                  <strong>COMPULSORY EXCESS</strong><br />
                  <label> In addition to the excess shown in the Schedule, we have the right to<br /> deduct another
                    RM400 as
                    Compulsory Excess if at the time <br />
                    of the accident. You or the person driving Your car with Your consent: </label>

                  <br />
                  <br />
                  - is Under 21 years old; or <br />
                  - Holds a Provisional(P) or Learner(L) driver's license; or <br />
                  - is not named in the Schedule as Named Driver<br /><br />

                  <label> We will deduct this additional RM400 Excess if the loss or damaged <br />is caused by fire,
                    explosion,
                    lighting, burglary, housebreaking, theft,<br /> third party propery damage or bodily injured claims.
                  </label>
                  <br />
                  <br />
                  <strong>EXCESS CLAIM DAMAGE</strong><br />
                  <label>
                    Refers to the excess amount you have agreed to pay on the own damage<br /> claim as specified in
                    your
                    Policy during the Period of cover.
                  </label>
                </div>
              </ng-template>

              <!-- <nz-card style="background-color: #F0D5D2 !important;" nzType="inner">
                <form [formGroup]="specialRequestForm">
                  <div class="row">
                    <label class="col-md-2 col-form-label"><strong style="font-weight: bold;">Special
                        Request:</strong></label> <br />
                  </div>


                  <textarea maxlength="200" formControlName="specialRequest" rows="3" placeholder=""
                    class="form-control"></textarea>
                  <br />
                  <button type="button" class="me-1 btn btn-info ng-star-inserted"
                    (click)="submitSpecialRequest()"><strong>Submit </strong></button>
                </form>
              </nz-card> -->



              <br />

              <div class="row">
                <div class="col-6">
                  <button type="button" class="btn btn-block btn-outline-danger active"
                    (click)="pre()"><strong>Back</strong></button>
                </div>
                <div class="col-6">
                  <button type="button" class="btn btn-block btn-outline-danger active"
                    (click)="next()"><strong>Next</strong></button>
                </div>
              </div>

            </div>

            <div class="steps-content" *ngIf="current==3">
              <form [formGroup]="personalDetailsForm">

                <label style="font-weight: bold;">{{this.idTypeLabel}} Details</label>
                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div *ngIf="this.isCompanySelected()">Company Name<span class="require-asterisk">*</span></div>
                    <div *ngIf="!this.isCompanySelected()">Individual Name<span class="require-asterisk">*</span></div>
                  </label>
                  <div class="col-md-8">
                    <input type="text" formControlName="name" placeholder="Key in owner name as per registration card"
                      class="form-control capitalise" [ngClass]="{
                                  'is-invalid': pdfSubmitted &&  pdf.name.errors
                                }" required />
                    <div *ngIf="pdfSubmitted && pdf.name.errors" class="invalid-feedback">
                      <div *ngIf="pdf.name.errors.required">Name is required</div>
                    </div>
                  </div>
                </div>
                <div class="form-group row" *ngIf="this.isCompanySelected()">
                  <label class="col-md-3 col-form-label">
                    <div>Tax Identification Number(TIN)<span class="require-asterisk">*</span></div>
                  </label>
                  <div class="col-md-8">
                    <input type="text" max="20" formControlName="tin" placeholder="Company Tax Identification Number"
                      class="form-control capitalise" [ngClass]="{
                                  'is-invalid': pdfSubmitted &&  pdf.tin.errors
                                }" />
                    <div *ngIf="pdfSubmitted && pdf.tin.errors" class="invalid-feedback">
                      <div *ngIf="pdf.tin.errors.required">TIN is required</div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>Email<span class="require-asterisk">*</span></div>
                  </label>
                  <div class="col-md-8">
                    <input type="text" maxlength="50" formControlName="email" class="form-control" [ngClass]="{
                            'is-invalid': pdfSubmitted &&  pdf.email.errors
                          }" email />
                    <div *ngIf="pdfSubmitted && pdf.email.errors" class="invalid-feedback">
                      <div *ngIf="pdf.email.errors.required">Email is required</div>
                      <div *ngIf="pdf.email.errors.email">Invalid Email</div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>Mobile Number<span class="require-asterisk">*</span></div>
                  </label>
                  <div class="col-md-8">
                    <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      formControlName="contactNo1" maxlength="12" placeholder="e.g: 018666666" class="form-control"
                      [ngClass]="{
                              'is-invalid': pdfSubmitted &&  pdf.contactNo1.errors
                            }" />
                    <div *ngIf="pdfSubmitted && pdf.contactNo1.errors" class="invalid-feedback">
                      <div *ngIf="pdf.contactNo1.errors.required">Mobile Number is required</div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>Second Mobile Number. (Optional)</div>
                  </label>
                  <div class="col-md-8">
                    <input type="text" formControlName="contactNo2" maxlength="12"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="e.g: 018666666"
                      class="form-control" [ngClass]="{'is-invalid': pdfSubmitted &&  pdf.contactNo2.errors}" />
                    <div *ngIf="pdfSubmitted && pdf.contactNo2.errors" class="invalid-feedback">
                      <div *ngIf="pdf.contactNo2.errors.required">Mobile Number is required</div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>Marital Status</div>
                  </label>
                  <div class="col-md-8">
                    <select class="form-control" formControlName="maritalStatus">
                      <option value="single">Single</option>
                      <option value="married">Married</option>
                      <option value="divorced">Divorced</option>
                      <option value="widowed">Widowed</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row"
                  *ngIf="(this.isKurniaSelected() || this.isChubbSelected()) && this.displayEinvoiceRequiredOption()">
                  <label class="col-md-3 col-form-label">
                    <div>E-Invoice Required?</div>
                  </label>
                  <div class="col-md-8">
                    <select class="form-control" (change)="compulsoryOptInForEinvoiceOnChange($event.target.value)"
                      formControlName="compulsoryOptInForEinvoice"
                      [ngClass]="{'is-invalid': pdfSubmitted &&  pdf.compulsoryOptInForEinvoice.errors}">
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                    <div *ngIf="pdfSubmitted && pdf.compulsoryOptInForEinvoice.errors" class="invalid-feedback">
                      <div *ngIf="pdf.compulsoryOptInForEinvoice.errors.required">Please select whether is E-Invoice
                        required</div>
                    </div>
                  </div>
                </div>

                <div *ngIf="displayEinvoiceSession()">
                  <label style="font-weight: bold;">Tax Details</label>

                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>TIN:<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" formControlName="tin" placeholder="Tax Identification Number"
                        class="form-control" (keypress)="keyPressAlphaNumeric($event)" [ngClass]="{
                                  'is-invalid': pdfSubmitted &&  pdf.tin.errors
                                }" />
                      <div *ngIf="pdfSubmitted && pdf.tin.errors" class="invalid-feedback">
                        <div *ngIf="pdf.tin.errors.required">Tax identification Number(TIN) is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>SST Registration Number:</div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" formControlName="sstRegNo" placeholder="SST Registration Number"
                        class="form-control" (keypress)="keyPressAlphaNumeric($event)" [ngClass]="{
                                  'is-invalid': pdfSubmitted &&  pdf.sstRegNo.errors
                                }" />
                      <div *ngIf="pdfSubmitted && pdf.sstRegNo.errors" class="invalid-feedback">
                        <div *ngIf="pdf.sstRegNo.errors.required">SST Registration Number is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" *ngIf="this.isCompanySelected()">
                    <label class="col-md-3 col-form-label">
                      <div>MSIC Code:<span class="require-asterisk" *ngIf="this.isCompanySelected()">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <nz-select nzShowSearch formControlName="msicCode" class="form-control" [nzShowArrow]="true"
                        nzBorderless nzPlaceHolder="Select MSIC Code" [ngClass]="{
                                  'is-invalid': pdfSubmitted &&  pdf.msicCode.errors
                                }">
                        <nz-option *ngFor="let item of msicList" [nzLabel]="item.key +' - '+ item.value"
                          [nzValue]="item.key">
                        </nz-option>
                      </nz-select>

                      <div *ngIf="pdfSubmitted && pdf.msicCode.errors" class="invalid-feedback">
                        <div *ngIf="pdf.msicCode.errors.required">MSIC code is required</div>
                      </div>

                    </div>
                  </div>
                </div>
                <label style="font-weight: bold;">Address</label>
                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>Address Line 1 <span class="require-asterisk">*</span></div>
                  </label>
                  <div class="col-md-8">
                    <input maxlength="50" formControlName="address1" rows="3" placeholder="Postal address"
                      class="form-control capitalise" [ngClass]="{
                            'is-invalid': pdfSubmitted &&  pdf.address1.errors
                          }" />
                    <div *ngIf="pdfSubmitted && pdf.address1.errors" class="invalid-feedback">
                      <div *ngIf="pdf.address1.errors.required">Address 1 is required</div>
                    </div>
                  </div>

                </div>
                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>Address Line 2 <span class="require-asterisk">*</span></div>
                  </label>
                  <div class="col-md-8">
                    <input maxlength="50" formControlName="address2" rows="3" placeholder=""
                      class="form-control capitalise" [ngClass]="{
                            'is-invalid': pdfSubmitted &&  pdf.address2.errors
                          }" />
                    <div *ngIf="pdfSubmitted && pdf.address2.errors" class="invalid-feedback">
                      <div *ngIf="pdf.address2.errors.required">Address 2 is required</div>
                    </div>
                  </div>

                </div>
                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>State</div>
                  </label>
                  <div class="col-md-8">
                    <nz-select class="form-control" formControlName="state" style="height: auto"
                      nzPlaceHolder="Please select" [nzShowArrow]="true" nzShowSearch nzBorderless>

                      <nz-option nzValue="Selangor" nzLabel="Selangor"></nz-option>
                      <nz-option nzValue="Kuala Lumpur" nzLabel="Kuala Lumpur"></nz-option>
                      <nz-option nzValue="Johor" nzLabel="Johor"></nz-option>
                      <nz-option nzValue="Kedah" nzLabel="Kedah"></nz-option>
                      <nz-option nzValue="Kelantan" nzLabel="Kelantan"></nz-option>
                      <nz-option nzValue="Melaka" nzLabel="Melaka"></nz-option>
                      <nz-option nzValue="Negeri Sembilan" nzLabel="Negeri Sembilan"></nz-option>
                      <nz-option nzValue="Pahang" nzLabel="Pahang"></nz-option>
                      <nz-option nzValue="Perak" nzLabel="Perak"></nz-option>
                      <nz-option nzValue="Perlis" nzLabel="Perlis"></nz-option>
                      <nz-option nzValue="Pulau Pinang" nzLabel="Pulau Pinang"></nz-option>
                      <nz-option nzValue="Putrajaya" nzLabel="Putrajaya"></nz-option>
                      <nz-option nzValue="Terengganu" nzLabel="Terengganu"></nz-option>
                    </nz-select>
                  </div>
                  <div *ngIf="pdfSubmitted && pdf.state.errors" class="invalid-feedback">
                    <div *ngIf="pdf.state.errors.required">Address 2 is required</div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>Postcode<span class="require-asterisk">*</span></div>
                  </label>
                  <div class="col-md-8">
                    <input type="text" maxlength="5" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      formControlName="postcode" placeholder="e.g: 68000" maxlength="5" class="form-control" [ngClass]="{
                                'is-invalid': pdfSubmitted &&  pdf.postcode.errors
                              }" required />
                    <div *ngIf="pdfSubmitted && pdf.postcode.errors" class="invalid-feedback">
                      <div *ngIf="pdf.postcode.errors.required">Postcode is required</div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-3 col-form-label">
                    <div>Remark</div>
                  </label>
                  <div class="col-md-8">
                    <textarea formControlName="remark" maxlength="1000" rows="3" placeholder=""
                      class="form-control capitalise">
                        </textarea>
                  </div>

                </div>
                <div style="font-size: small;" *ngIf="!this.isChubbSelected()">
                  <strong>1.</strong> I/We hereby confirm that all of our answers and statements are true
                  and accurate. l/we have not withheld any information whatever
                  regarding this application knowing that it is my/our duty to take
                  reasonable care not to make a misrepresentations in answering the
                  questions in this application.
                  <br>

                  <div>
                    <div *ngIf="this.isKurniaSelected()">
                      <strong>2.</strong> Purchasing this product through Brilliant Management Services will provide you
                      with a personalised product and claim services. You may consider exploring alternative options at
                      Liberty General Insurance Berhad, where you will be entitled for a commission rebate.
                    </div>
                    <div *ngIf="!this.isZurichSelected() && !this.isKurniaSelected()">
                      <strong>2.</strong> Purchasing this product​ through 'BMS' will provide​ you with a
                      seamless and personalized product/claim services. However, you may consider commission rebates or
                      commission-free products which can be purchased directly from {{getInsuranceCompanyFullName()}}
                      branches and website.​
                    </div>
                  </div>



                  <div *ngIf="this.isZurichSelected()">
                    <br>
                    <div>
                      <strong>2.</strong> Purchasing this product​ through 'BMS RoadTax Services(003219451-V)' will
                      provide​ you with a
                      seamless and personalized product/claim services.​ You may purchase in a similar product directly
                      from {{getInsuranceCompanyFullName()}}. You will self service your insurance needs or contact <a
                        href="{{getInsuranceCompanyLink()}}" target="_blank">{{getInsuranceCompanyShortName()}}</a> for
                      assistance. There is no commission involved when purchasing directly with
                      {{getInsuranceCompanyFullName()}}.
                    </div>
                    <br>
                    <strong>3.</strong> '{{selectedPlan}}' is underwritten by Zurich General Insurance Malaysia
                    Berhad a licensed insurer under the Financial Services Act 2013 and
                    regulated by Bank Negara Malaysia. 'BMS RoadTax Services(003219451-V)' is an authorized distributor
                    of Zurich General
                    Insurance Malaysia Berhad .
                    <br>
                    <strong>4.</strong> The benefit(s) payable under eligible product is protected by PIDM up to
                    limits. Please refer to <a target="_blank"
                      href="https://www.pidm.gov.my/getContentAsset/df69753b-0f66-45bd-a13c-31490c3ded0b/188ea75b-0100-4438-8f97-d79a01d9e0cd/Deposit-Insurance-System-Brochures.pdf?language=en">PIDM’s
                      TIPS Brochure</a> or contact <a href="https://www.zurich.com.my" target="_blank">Zurich General
                      Insurance Malaysia Berhad</a> or <a
                      href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf"
                      target="_blank">PIDM</a>
                    <br>
                    <label> <input type="checkbox" style="vertical-align:bottom; zoom:1.5;" /> I would like to receive
                      latest marketing and
                      promotional news from entities within Zurich Malaysia financial group and business partners of
                      Zurich. <label style="color: red;">[Optional]</label>
                    </label>
                    <label>
                      <input type="checkbox" style="vertical-align:middle; zoom:1.5;"
                        (change)="onCondition2Checked($event)" /> Please read and understand the <a
                        href="{{getProductDisclosureLink}}" target="_blank">Product Disclosure Sheet</a> and the <a
                        href="https://www.zurich.com.my/-/media/project/zwp/malaysia/docs/insurance-products/zgimb-duty-of-disclosure"
                        target="_blank">Duty of Disclosure</a> before buy this product. You may contact us if you have
                      any
                      product enquiries.<label style="color: red;">[Mandatory]</label>
                    </label>
                    <label> <input type="checkbox" style="vertical-align:bottom; zoom:1.5;"
                        (change)="onCondition3Checked($event)" /> I confirm that
                      the information provided in this application is complete and
                      accurate. I have read and consent to the processing of my personal data in
                      accordance with the <a target="_blank" href="https://www.zurich.com.my/en/customer-hub/show-me-more-info/personal-
data-protection-notice">NOTICE TO CUSTOMERS RELATING TO THE
                        PERSONAL DATA PROTECTION ACT 2010</a> as published on Zurich Malaysia’s website.<label
                        style="color: red;">[Mandatory]</label>
                    </label>
                  </div>
                  <br>

                  <div>
                    <label *ngIf="!this.isZurichSelected()"> <input type="checkbox"
                        style="vertical-align:bottom; zoom:1.5;" /> I/We would like to
                      receive special offers, promotions and information related to the insurance products, events and
                      services of
                      {{getInsuranceCompanyFullName()}} and/or it's agent
                      Brilliant Management Services (BMS). <label style="color: red;">[Optional]</label>
                    </label>

                    <label *ngIf="!this.isZurichSelected()">
                      <input type="checkbox" style="vertical-align:middle; zoom:1.5;"
                        (change)="onCondition2Checked($event)" /> I/We hereby confirm that l/we have read and
                      understood the <a href="{{getProductDisclosureLink}}" target="_blank">Product Disclosure Sheet</a>
                      & <a href="{{getPolicyWording}}" target="_blank">Policy Wording</a> agreed to be bound
                      by the terms and conditions stipulated therein. I have also taken note
                      of the duties of the Policy Owner under the Policy Contract and where
                      required have contacted representatives of {{getInsuranceCompanyFullName()}} directly for any
                      terms that I/We do not understand
                      prior to entering into this contract.<label style="color: red;">[Mandatory]</label>
                    </label>

                    <label *ngIf="!this.isZurichSelected() && !this.isTuneSelected()"> <input type="checkbox"
                        style="vertical-align:bottom; zoom:1.5;" (change)="onCondition3Checked($event)" /> I/We hereby
                      consent for 'BMS' &
                      {{getInsuranceCompanyFullName()}} and/or any company within the 'BMS' &
                      {{getInsuranceCompanyShortName()}} Group of
                      Companies and/or any of its associated companies. within or outside
                      Malaysia, process my/our Personal Data for the purposes and to the
                      extent stated in the <a target="_blank" href="https://bmsroadtax.com/">'BMS Privacy
                        Notice'</a> &

                      <a target="_blank"
                        href="{{getInsuranceCompanyPrivacyPolicyLink()}}">{{getInsuranceCompanyFullName()}}
                        Data Privacy Notice. </a><label style="color: red;">[Mandatory]</label>
                    </label>

                    <label *ngIf="this.isTuneSelected()"> <input type="checkbox"
                        style="vertical-align:bottom; zoom:1.5;" (change)="onCondition3Checked($event)" /> I/We hereby
                      agree for my personal data be used to receive marketing content and promotional offers from Tune
                      Protect Group and its affiliated companies. I further understand that I may withdraw such consent
                      in accordance with terms under Tune Protect’s <a target="_blank"
                        href="https://www.tuneprotect.com/my/privacy-policy/">Privacy Policy</a>.
                    </label>


                  </div>

                </div>


                <div style="font-size: small;" *ngIf="this.isChubbSelected()">
                  <strong>1.</strong> For same products, you may visit any Chubb's branches to enjoy premium rebate.
                  <br>
                  <strong>2.</strong> You/the intended policyholder must submit all claims directly to Chubb Claims within 30 days after the
                  occurrence of the loss. You can submit your motor claims via <a
                    href="https://clientportal.merimen.com/public/client/clp/ClpDashboard?ins_code=MY_chubb"
                    target="_blank"> Chubb Motor Claims Online Portal</a>.
                  <br>
                  <strong>3.</strong> Should you require additional information, including on product inquiries or the claims process, you can contact your agent, Lim Siew
                  Tin
                  at 1300 88 5755. You can also refer to the insuranceinfo booklet available at Chubb's branches or you
                  can obtain a copy from <a href="https://www.insuranceinfo.com.my"
                    target="_blank">www.insuranceinfo.com.my</a>.
                  <br>

                  <label> <input type="checkbox" style="vertical-align:bottom; zoom:1.5;"
                      (change)="onCondition3Checked($event)" /> I/the intended policyholder hereby confirm that
                    all of our answers and statements are true
                    and accurate. l/we have not withheld any information whatever
                    regarding this application knowing that it is my/our duty to take
                    reasonable care not to make a misrepresentations in answering the
                    questions in this application. <label style="color: red;">[Mandatory]</label>
                  </label>
                  <label>
                    <input type="checkbox" style="vertical-align:middle; zoom:1.5;"
                      (change)="onCondition2Checked($event)" />
                    Yes, I/the intended policyholder have read and agreed to the Chubb Insurance Malaysia Berhad's ("Chubb") <a
                      href="https://www.chubb.com/content/dam/chubb-sites/chubb-com/my-en/campaign/goinsure/documents/pdf/declaration-authorization.pdf"
                      target="_blank">Declaration &
                      Authorisation</a>, <a href="{{getPolicyWording}}" target="_blank">Policy Wording</a> and <a
                      href="{{getProductDisclosureLink}}" target="_blank">Product Disclosure Sheet</a>, and Personal Data Protection Notice, and confirm that the eligibility requirements of the insurance policy are met. In line with the Personal Data Protection Act 2010 (PDPA), we seek your consent as our customer to be given to us to use, process and/or retain your personal data. In short, PDPA protects your personal data. We would like to seek your full co‐operation to grant us your consent by completing this Personal Data Protection
                    <label style="color: red;">[Mandatory]</label>
                  </label>

                  <label> <input type="checkbox" style="vertical-align:middle; zoom:1.5;"
                      (change)="onCondition1Checked($event)" /> I / the intended policyholder hereby consent to my / the intended policyholder’s personal data such as name and contact number being disclosed to and used by Chubb’s related companies and third party providing telemarketing services for purposes of marketing/promotions of other Chubb financial products.
                  </label>


                  <br>
                </div>
                <!-- <div>
                  <label> <input type="checkbox" style="vertical-align:middle; zoom:1.5;"
                      (change)="onCondition1Checked($event)" /> I/We have read and agree with the Terms &
                    Conditions above. <label style="color: red;">[Mandatory]</label>
                  </label>
                </div> -->

                <div
                  style="font-size: 11px; color: blue;  display: flex; justify-content: center; align-items: center; text-align: center;">

                  <span style="font-weight: bold;">
                    <nz-icon nzType="info-circle" nzTheme="outline" style="margin-right: 4px;"></nz-icon>Your Product
                    Disclosure Sheet & Policy Wording is available in digital format only. Please download
                    and keep for future reference.
                  </span>
                </div>
                <br />
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn btn-block btn-outline-danger active" (click)="pre()">Back</button>
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn btn-block btn-outline-danger active"
                      [disabled]="isMakePaymentBtnDisabled" (click)="submitQuotation()"><strong>Make
                        Payment</strong></button>
                  </div>
                </div>
              </form>

            </div>


          </div>
        </div>
        <div style="text-align: center;font-size: 10px;"> <label><Strong>Copyright ©️ 2025 BMS ROADTAX E PLATFORM
              202403148877 (KT0570731-V). All Rights
              Reserved.</Strong></label></div>

      </div>



    </div>